import React from 'react'
import PropTypes from 'prop-types'

import CoverImage from 'images/backgrounds/events/events_bg.jpg'
import PageHeader from './Components/PageHeader'
import EventsCard from './Components/EventsCard'


class EventsList extends React.Component {
  render() {
    return (
      <div className="events-page">
        <PageHeader
          image={CoverImage}
          title="CGTrader Event Calendar"
          subtitle="Let’s meet in person to discuss all of your 3D content requirements"
        />
        <div className="container-fixed">
          <div className="row events-list">
            <div className="col-12 col-xl-10 offset-xl-1">
              {this.props.data.length ? (
                this.props.data.map(row => (
                  <EventsCard
                    key={row.id}
                    title={row.attributes.title}
                    image={row.attributes.image}
                    dateFrom={row.attributes.dateFrom}
                    dateTo={row.attributes.dateTo}
                    address={row.attributes.address}
                    description={row.attributes.description}
                    slug={row.attributes.slug}
                    subtitle={row.attributes.subtitle}
                  />
                ))
              ) : (
                <div className="col-12 events-list__empty-screen">
                  <p className="heading-32 u-text-center">Currently there are no upcoming events</p>
                  <p className="heading-20 u-text-center">Stay tuned - new events will be announced soon</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

EventsList.propTypes = {
  data: PropTypes.array.isRequired,
}

export default EventsList
